import { useCallback, useEffect, useState } from 'react';
import { UserAccount, UserRole } from '../types';
import { mockBackend } from '../services/mockBackend';
import { userFacingError } from '../utils/errors';

type UserAdminPanelProps = {
  refreshToken: number;
  onActionComplete: () => void;
};

const UserAdminPanel = ({ refreshToken, onActionComplete }: UserAdminPanelProps) => {
  const [users, setUsers] = useState<UserAccount[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadUsers = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const items = await mockBackend.auth.listUsers();
      setUsers(items);
    } catch (loadError) {
      setError(userFacingError(loadError, 'Não foi possível carregar os usuários.'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void loadUsers();
  }, [loadUsers, refreshToken]);

  const updateRole = async (userId: string, role: UserRole) => {
    setError('');
    try {
      await mockBackend.auth.updateUserRole(userId, role);
      await loadUsers();
      onActionComplete();
    } catch (updateError) {
      setError(userFacingError(updateError, 'Não foi possível atualizar o perfil do usuário.'));
    }
  };

  return (
    <div className="card bg-onyx border-0 shadow-lg">
      <div className="card-body p-4">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div>
            <h5 className="text-white mb-1">Usuários e papéis</h5>
            <p className="text-white-50 mb-0">Gestão simples de administradores e criadores.</p>
          </div>
          <span className="badge bg-brand text-white">{users.length}</span>
        </div>

        {error && <div className="alert alert-danger py-2">{error}</div>}
        {loading && <div className="text-white-50">Carregando usuários...</div>}

        <div className="user-list">
          {users.map((user) => (
            <div key={user.id} className="user-row">
	              <div>
	                <strong className="d-block text-white">{user.name}</strong>
	                <span className="text-white-50 small">{user.email}</span>
	                {user.contactPhone && (
	                  <span className="text-white-50 small d-block">{user.contactPhone}</span>
	                )}
	              </div>
              <select
                className="form-select input-contrast"
                style={{ width: 180 }}
                value={user.role}
                onChange={(event) => updateRole(user.id, event.target.value as UserRole)}
              >
                <option value="criador">Criador</option>
                <option value="admin">Administrador</option>
              </select>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserAdminPanel;
